// import toast from "react-hot-toast";
import toast from "react-hot-toast";
import axiosInstance from "./axios";
import { logout } from "../store/slice/authSlice";
// import { errorMessageToast } from "helpers/common"
// import { logout } from "store/slices/authSlice"

const axiosBaseQuery =
  ({ baseUrl } = { baseUrl: "" }) =>
  async (arg, { dispatch }, extraOptions) => {
    console.log("arg", arg);
    try {
      const config = typeof arg === "string" ? { url: arg } : arg;

      console.log(config);

      let {
        url,
        method = "GET",
        data = undefined,
        params = null,
        headers = {},
      } = config;

      const result = await axiosInstance({
        url: baseUrl + url,
        method,
        data,
        params,
        headers,
      });
      if (result?.status !== "success") {
        throw new Error("Response was not ok");
      }

      return {
        data: result || null,
      };
    } catch (axiosError) {
      console.error("Error occurred in API request: ", axiosError);
      const err = axiosError;
      if (err?.status === 401) {
        console.log(401);
        dispatch(logout());
        return;
      }
      if (!extraOptions?.suppressErrorToast) {
        console.log("err", err);

        toast.error(err.response?.data?.message || "Something went wrong!");
      }
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export default axiosBaseQuery;
